module.exports = __webpack_public_path__ + "static/edit-store-address-phone-8f2e03b80a4122a342f72acda5c58ea4.png";